import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  h1: {
    ...theme.rccl.subtitle1,
    ...{
      color: theme.palette.blue1,
      marginBottom: '18px',
      fontSize: theme.typography.pxToRem(32),
    },

    [theme.breakpoints.down('md')]: {
      fontSize: theme.typography.pxToRem(24),
    },

    [theme.breakpoints.down('xs')]: {
      fontSize: theme.typography.pxToRem(18),
    },
  },
  notificationContainer: {
    color: theme.palette.grey1,
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(18),
    },
  },
  paymentOverlay: {
    padding: 0,
    maxWidth: 1080,
    fontFamily: theme.typography.proxima.regular,

    [theme.breakpoints.down('lg')]: {
      padding: '13px 50px',
    },

    [theme.breakpoints.down('sm')]: {
      padding: '13px 20px 27px 20px',
      width: '100%',

      '& [class*="-pageSection-"]': {
        padding: '33px 0 0 0',
      },
    },

    '& .titleText': {
      fontSize: theme.typography.pxToRem(32),

      [theme.breakpoints.down('md')]: {
        fontSize: theme.typography.pxToRem(24),
      },
    },

    '& .paymentOverlayWrapper': {
      paddingTop: '12px',
    },
  },
  card: {
    backgroundColor: 'white',
    boxShadow: '1px 3px 4px -1px rgba(6,21,86,0.10)',
  },
  itInfo: {
    marginBottom: '18px',
    '& span': {
      fontSize: theme.typography.pxToRem(16),
      color: theme.palette.grey1,
    },
    '& h2': {
      color: theme.palette.grey2,
      fontSize: theme.typography.pxToRem(14),
      marginBottom: theme.typography.pxToRem(1),
      textTransform: 'uppercase',
      letterSpacing: theme.typography.pxToRem(2),
      fontFamily: theme.typography.proxima.regular,
    },
  },
  itInlineDate: {
    display: 'flex',
    fontSize: theme.typography.pxToRem(16),
    justifyContent: 'flex-start',
    textTransform: 'capitalize',
    '& .from': {
      marginRight: '4px',
      color: theme.palette.grey1,
    },
    '& .to': {
      marginLeft: '4px',
      color: theme.palette.grey1,
    },
    '& svg': {
      width: '15px',
      color: theme.palette.grey2,
    },
  },
  notification: {
    marginBottom: '40px',
    marginTop: '40px',
    [theme.breakpoints.down('lg')]: {
      marginTop: '83px',
    },
    [theme.breakpoints.down('sm')]: {
      margin: '0px -16px 30px',
    },
  },
}));

export default useStyles;
